import { StoreState } from '@/core/models/store.interface';
import { CancelToken } from 'axios';
import { Module } from 'vuex';
import { Availability } from './availability.interface';
import availabilityService from './availability.service';

export interface AvailabilityState {
   candidate_availibilities: Array<Availability>;
   selected_date: Date;
   between_start?: string;
   between_end?: string;
   selected_availability?: Availability;
}

const AvailabilityStore: Module<AvailabilityState, StoreState> = {
   namespaced: true,
   state: {
      candidate_availibilities: [],
      selected_date: new Date(),
   },

   getters: {},

   mutations: {
      setCandidateAvailabilities(state, candidate_availibilities) {
         state.candidate_availibilities = candidate_availibilities;
      },
      setBetweenScope(state, { between_start, between_end }: { between_start: string; between_end: string }) {
         state.between_start = between_start;
         state.between_end = between_end;
      },
   },

   actions: {
      async get(
         context,
         {
            candidate_id,
            between_start,
            between_end,
            cancel_token,
         }: { candidate_id: number; between_start: string; between_end: string; cancel_token: CancelToken },
      ) {
         return await availabilityService.get(candidate_id, between_start, between_end, cancel_token).then((response) => {
            context.commit('setBetweenScope', { between_start, between_end });
            context.commit('setCandidateAvailabilities', response);
            return response;
         });
      },
   },
};

export default AvailabilityStore;
